/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxStandardDto } from '../../models/backend-tax-standard-dto';

export interface ProjectTaxesTaxStandardRetrieve$Params {
  id: number;
}

export function projectTaxesTaxStandardRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxStandardRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxStandardRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxStandardDto>;
    }),
  );
}

projectTaxesTaxStandardRetrieve.PATH = '/api/project_taxes/tax_standard/{id}/';
